import {
  MY_ASSESSMENT_STATUS,
  getCalendarDisplayStatus,
  getRowDisplayStatus,
  getSponsorPrimaryBadge,
} from "./assessmentCalendarRules";

function dedupeSecondary(primary, secondary) {
  if (!primary || !secondary) return secondary;
  if (String(primary).trim().toLowerCase() === String(secondary).trim().toLowerCase()) {
    return null;
  }
  return secondary;
}

export function getCalendarRowBadges(row, { isAdmin, today } = {}) {
  if (isAdmin) {
    return {
      requestType: row?.request_type || null,
      primary: getRowDisplayStatus(row, { isAdmin: true, today }),
      secondary: null,
    };
  }

  const primary = getSponsorPrimaryBadge(row);
  const secondary = dedupeSecondary(
    primary,
    primary === MY_ASSESSMENT_STATUS ? getCalendarDisplayStatus(row, today) : null
  );

  return { requestType: null, primary, secondary };
}
